var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22_Mobile-Applications",
    transform: "translate(-621.000000, -239.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(320.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trustgrid-Citizen-App",
    transform: "translate(40.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Android",
    transform: "translate(240.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6314657,25.900264 L24.6185587,17.3187641 C24.2537401,17.1101985 23.8386624,17 23.4184023,17 C22.9926665,17 22.5729931,17.1129363 22.2047521,17.3265865 C21.4616212,17.7577002 21,18.559206 21,19.4184023 L21,36.5815 C21,37.4405984 21.4616212,38.2421042 22.2045566,38.673218 C22.5727975,38.8870637 22.9925687,39 23.4183045,39 C23.838369,39 24.2534468,38.8897037 24.6184609,38.6811382 L39.6311724,30.0995404 C40.3827124,29.6698934 40.849516,28.8654542 40.849516,27.9999022 C40.849516,27.1343502 40.382908,26.329911 39.6314657,25.900264 Z M33.1258434,23.8711255 L31.0645351,26.7423487 L26.1339591,19.87445 L33.1258434,23.8711255 Z M26.1339591,36.1254522 L31.0645351,29.2574558 L33.1258434,32.128679 L26.1339591,36.1254522 Z M38.9034908,28.8260487 L34.4059842,31.3968906 L31.9672436,27.9999022 L34.4059842,24.6029139 L38.9034908,27.1737557 C39.1991786,27.342818 39.382908,27.6593331 39.382908,27.9999022 C39.382908,28.3404713 39.1992764,28.6570842 38.9034908,28.8260487 Z",
    id: "android"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.37b83304b98f9aaf0e2756c86d150bdf.svg";
export { ForwardRef as ReactComponent };